// crypto_utils.js
import CryptoJS from "crypto-js";

const ENCRYPTION_KEY =
  process.env.REACT_APP_STORAGE_ENCRYPTION_KEY || "default-secure-key";

/*
   const authData = {
      token: response.token,
      user: {
        id: response.user.id,
        email: response.user.email,
        roles: response.user.roles,
        firstName: response.user.firstName || '',
        lastName: response.user.lastName || '',
      },
      tenant: response.tenant ? {
        id: response.tenant.id,
        name: response.tenant.name,
        handle: response.tenant.handle,
      } : null,
      timestamp: new Date().getTime(), // For token freshness check
    };

    // Encrypt the auth data before storage
    const encryptedAuthData = encryptData(authData);
*/
export const encryptData = (data) => {
  try {
    return CryptoJS.AES.encrypt(
      JSON.stringify(data),
      ENCRYPTION_KEY
    ).toString();
  } catch (error) {
    console.error("Encryption failed:", error);
    throw new Error("Failed to encrypt data");
  }
};

export const decryptData = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, ENCRYPTION_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
